// @flow

import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import moment from 'moment';
import { getMediaByGallery, MANAGER_PICTURE } from '../../../utils/keepeekUtils';
import { getCurrentPcId, getCurrentShoppingCenter } from '../../../utils/urlUtils';
import type { PracticalInfos, Schedule, ShoppingCenter } from '../../../types/shoppingCenterType';
import { ScheduleBean } from '../../../types/shoppingCenterType';
import type { MediaGallery } from '../../../types/keepeekType';
import shoppingCenterApi from '../../../network/api/shoppingCenterApi';
import opening from '../../../img/KeyDateImage/opening.png';
import { notifyApolloError } from '../../../network/notification';
import { fetchPracticalInfos } from '../../../state/shopping-centers/shoppingCentersService';

type Props = {
  dispatch: () => void,
  shoppingCenterMedia: MediaGallery[],
  baseShoppingCenterList: ShoppingCenter[],
  location: Location,
  practicalInfos: ?PracticalInfos,
}

type State = {
  specialSchedule: Schedule[],
  openingSchedule: Schedule[],
  selectedSchedule: number,
}

class PracticalInfo extends React.Component<Props, State> {
  state: State = {
    specialSchedule: [],
    openingSchedule: [],
    selectedSchedule: 0,
  };

  componentDidMount() {
    this.props.dispatch(fetchPracticalInfos(getCurrentPcId()));
    shoppingCenterApi.fetchSchedules(getCurrentPcId())
      .then(resp => resp.json())
      .then((scheduleBean: ScheduleBean) => {
        const openingSchedule = scheduleBean.storeSchedule
          .sort((a: Schedule, b: Schedule) => a.displayOrder - b.displayOrder);
        this.setState({
          selectedSchedule: 0,
          openingSchedule,
          specialSchedule: scheduleBean.specialSchedule,
        });
      }).catch(e => this.props.dispatch(notifyApolloError(e)));
  }

  render() {
    const shoppingCenter =
      getCurrentShoppingCenter(this.props.location.search, this.props.baseShoppingCenterList);
    return (
      <div className="mall-practical-info">
        <div className="title">
          <Translate value="mallData.PRACTICAL_INFO_LABEL" />
        </div>
        <div className="practical-container">
          <div className="manager-container">
            {
              getMediaByGallery(this.props.shoppingCenterMedia, MANAGER_PICTURE)[0] &&
              <div className="manager-image-container">
                <img
                  alt="Best of"
                  className="manager-image"
                  src={getMediaByGallery(this.props.shoppingCenterMedia, MANAGER_PICTURE)[0].fullscreen}
                />
                {this.props.practicalInfos && this.props.practicalInfos.scManager &&
                <div className="manager-name">
                  <span>{this.props.practicalInfos.scManager.firstName} {this.props.practicalInfos.scManager.name}</span>
                  <span>Key Contact</span>
                </div>}
              </div>
            }
            {
              this.props.practicalInfos && this.props.practicalInfos.scManager &&
              <div className="manager-data">
                <div className="info">
                  <h3>{shoppingCenter && shoppingCenter.name}</h3>
                  <div>
                    {shoppingCenter && shoppingCenter.address}
                  </div>
                </div>
                <div className="info">
                  <h3>
                    {this.props.practicalInfos.scManager.firstName} {this.props.practicalInfos.scManager.name}
                  </h3>
                  {this.props.practicalInfos.scManager.mobilePhone &&
                  <Translate
                    value="mallData.PRACTICAL_INFO.MOBILE"
                    mobile={this.props.practicalInfos.scManager.mobilePhone}
                  />
                  }
                  {this.props.practicalInfos.scManager.email &&
                  <Translate
                    value="mallData.PRACTICAL_INFO.EMAIL"
                    email={this.props.practicalInfos.scManager.email}
                  />
                  }
                </div>
              </div>
            }
          </div>
          {this.state.openingSchedule.length > 0 &&
          <div className="open-hours-container">
            <div className="title-container">
              <img src={opening} alt="opening" />
              <div>
                <Translate value="mallData.PRACTICAL_INFO.OPENING_HOURS" />
              </div>
            </div>
            <div className="schedule-container">
              {
                this.state.openingSchedule[this.state.selectedSchedule].scheduleDetails
                  .sort((a, b) => a.day - b.day)
                  .map((scheduleDetails, index) => (
                    <div key={`${scheduleDetails.day}-${scheduleDetails.timeOpen}-${scheduleDetails.timeClose}`} className="schedule-line-container">
                      <div className="schedule-line">
                        <Translate value={`days.${scheduleDetails.day}`} />
                        <Translate
                          value="mallData.PRACTICAL_INFO.TO"
                          from={moment(scheduleDetails.timeOpen, 'hh:mm:ss').format('HH:mm')}
                          to={moment(scheduleDetails.timeClose, 'hh:mm:ss').format('HH:mm')}
                        />
                      </div>
                    </div>
                  ))
              }

            </div>
            <div
              className="schedule-selector-container"
            >
              {
                this.state.openingSchedule
                  .map((schedule: Schedule, index) => (
                    <button
                      key={`${schedule.title}-selector`}
                      className={`schedule-selector ${this.state.selectedSchedule === index ? 'selected' : ''}`}
                      onClick={() => this.setState({ selectedSchedule: index })}
                    >
                      {schedule.title}
                    </button>
                  ))
              }
            </div>
          </div>
          }
          {this.state.specialSchedule.length > 0 &&
          <div className="special-open-container">
            <div className="title-container">
              <img src={opening} alt="opening" />
              <div>
                <Translate value="mallData.PRACTICAL_INFO.SPECIAL_OPENING" />
              </div>
            </div>
            <div className="schedule-container">
              {
                this.state.specialSchedule
                  .map(schedule => (
                    <div key={schedule.exceptionDate} className="schedule-line-container">
                      <div
                        className="schedule-line"
                      >
                        <span>{moment(schedule.exceptionDate).format('ll')}</span>
                        <Translate
                          value="mallData.PRACTICAL_INFO.TO"
                          from={moment(schedule.scheduleDetails[0].timeOpen, 'hh:mm:ss').format('HH:mm')}
                          to={moment(schedule.scheduleDetails[0].timeClose, 'hh:mm:ss').format('HH:mm')}
                        />
                      </div>
                    </div>
                  ))
              }
            </div>
          </div>
          }
        </div>
      </div>
    );
  }
}

export default withRouter(connect(state => ({
  shoppingCenterMedia: state.shoppingCenterFilters.shoppingCenterMedia,
  practicalInfos: state.shoppingCenterFilters.practicalInfos,
  baseShoppingCenterList: state.shoppingCenterFilters.baseShoppingCenterList,
}))(PracticalInfo));
